import { MessageCircle } from "lucide-react";
import { CLINIC } from "@/data/site";

export default function WhatsAppFab() {
  const waLink = `https://wa.me/${CLINIC.phoneRaw}?text=${encodeURIComponent(
    "Hello, I would like to book an appointment with Dr. Pallavi Mishra."
  )}`;
  return (
    <a
      href={waLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 grid place-items-center w-14 h-14 rounded-full bg-brand text-white shadow-lg shadow-brand/30 hover:bg-brand-dark hover:scale-105 transition-[transform,background-color] duration-300"
    >
      <MessageCircle size={24} />
    </a>
  );
}
